export const ProjectData = [
    {
        subtext : 'Briefly',
        link: 'https://github.com/maxgonick/briefly',
        left : [
            'LA Hacks 2023',
            'Developed a web-app that summarizes state legislation through the power of CoHere AI',
            ],
        right : ['Tools: React.js, Next.js']
    },
    {
        subtext : 'Enable',
        link: 'https://github.com/theamandawang/Enable',
        left : [
            'Meta: Summer 2022',
            'Created an iOS app that provides accessibility information',
            ],
        right : ['Tools: Obj-C, Storyboard, Parse']
    },
    {
        subtext : 'Friend in Need',
        link: 'https://devpost.com/software/friend-in-need-67l9od',
        left : [
            'LA Hacks 2022',
            'Designed a web-app that helps students borrow from their peers',
            ],
        right : ['Tools: React.js, Firebase']
    },
    {
        subtext : 'WhatsBruin',
        link: 'https://github.com/RoryHemmings/WhatsBruin',
        left : [
            'CS35L: Spring 2022',
            'Created a UCLA events-calendar website',
            ],
        right : ['Tools: React, Node, Express, PostgreSQL']
    },
];